import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router";
import _ from 'lodash';
import cn from 'classnames';
import moment from 'moment';
import QueryString from 'query-string';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import GLOBAL_FILTER_CONTROLLER from '../../controllers/globalFilter';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import SingleCompanySelector from '../selectors/company/SingleCompanySelector';
import MonthSelector from '../selectors/date/MonthSelector';
import YearSelector from '../selectors/date/YearSelector';
import SingleCountrySelector from '../selectors/country/SingleCountrySelector';
import SimpleDateSelector from '../selectors/date/SimpleDateSelector';
import FilingTypeSelector from '../selectors/filing/FilingTypeSelector';
import OpenReturnsStatusSelector from '../openReturns/OpenReturnsStatusSelector';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const FORM_NAME = 'GLOBAL_FILTER_PANEL';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
const NOW = 'now';
const PARAM_COMPANY_ID = "companyId";
const PARAM_MONTH = "month";
const PARAM_YEAR = "year";
const PARAM_START_DATE = "startDate";
const PARAM_END_DATE = "endDate";
const PARAM_SIMPLE_DATE = 'date';
const PARAM_COUNTRY_CODE = "countryCode";
const PARAM_COMPANY_CODE = 'companyCode';
const PARAM_DEFAULT_YEAR = 'defaultYear';
const PARAM_DEFAULT_MONTH = 'defaultMonth';
const DATE_FORMAT = 'YYYY-MM-DD';
const PARAM_RETURN_TYPE = 'returnType';
const PARAM_RETURN_STATUS = 'returnStatus';
const PARAM_FILING_TYPE = 'filingType';

export const FILTER_PERIOD_GROUP = {
    MONTH_YEAR: "MONTH_YEAR",
    DATE_RANGE: "DATE_RANGE",
    SIMPLE_DATE: "SIMPLE_DATE",
    ALL: "ALL"
};
const ALL_PARAMS = [
    PARAM_COMPANY_ID,
    PARAM_MONTH,
    PARAM_YEAR,
    PARAM_START_DATE,
    PARAM_END_DATE,
    PARAM_COUNTRY_CODE,
    PARAM_COMPANY_CODE,
    PARAM_SIMPLE_DATE,
    PARAM_RETURN_TYPE,
    PARAM_RETURN_STATUS,
    PARAM_FILING_TYPE
];
const CONTROL_PARAMS = [
    PARAM_DEFAULT_MONTH,
    PARAM_DEFAULT_YEAR
];

const CONTROL_PARAMS_MAPPING = {};
CONTROL_PARAMS_MAPPING[PARAM_DEFAULT_MONTH] = PARAM_MONTH;
CONTROL_PARAMS_MAPPING[PARAM_DEFAULT_YEAR] = PARAM_YEAR;
export const FIELDS = {
    PARAM_COMPANY_ID,
    PARAM_SIMPLE_DATE,
    PARAM_MONTH,
    PARAM_YEAR,
    PARAM_START_DATE,
    PARAM_END_DATE,
    PARAM_COUNTRY_CODE,
    PARAM_COMPANY_CODE,
    PARAM_RETURN_STATUS,
    PARAM_RETURN_TYPE,
    PARAM_FILING_TYPE
};

const DEFAULT_FIELD_SETTING = {};
DEFAULT_FIELD_SETTING[PARAM_COMPANY_ID] = {
    useCompanyCode: false,
    customOptions: []
};

export class GlobalFilterPanel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            requiredFieldsMet: true,
            selection: {}
        };
        this.selectionHandler = this.selectionHandler.bind(this);
        this.onSearchClick = this.onSearchClick.bind(this);
        this.onSearchClickInErrorsAndWarnings = this.onSearchClickInErrorsAndWarnings.bind(this);
        this.adaptFilterPeriod = this.adaptFilterPeriod.bind(this);
        this.getFilterPeriodGroup = this.getFilterPeriodGroup.bind(this);
        this.isSearchDisabled = this.isSearchDisabled.bind(this);
        this.getCompanyOptions = this.getCompanyOptions.bind(this);
        this.companySelectionHandler = this.companySelectionHandler.bind(this);
        this.adaptCompanyId = this.adaptCompanyId.bind(this);
        this.findCompanyBy = this.findCompanyBy.bind(this);
        this.onCustomDatesClick = this.onCustomDatesClick.bind(this);
        this.monthYearClickHandler = this.monthYearClickHandler.bind(this);
        this.nextAndPrevMonthClickHandler = this.nextAndPrevMonthClickHandler.bind(this);
    }

    getCompanyOptions() {
        return this.props.fieldOptions[PARAM_COMPANY_ID] || DEFAULT_FIELD_SETTING[PARAM_COMPANY_ID];
    }

    findCompanyBy(key = 'id', value = '') {
        let matchedCompany = this.props.companyList.find((company) => {
            return `${company[key]}` === `${value}`;
        });
        return matchedCompany;
    }

    selectionHandler(keyValue) {
        log.debug('selectionHandler() - keyValue: ', keyValue);
        let key = Object.keys(keyValue)[0];
        let value = Object.values(keyValue)[0];
        let selection = Object.assign({}, this.state.selection);
        if (_.isEmpty(value)) {
            delete selection[key];
        } else {
            selection = Object.assign(selection, keyValue);
        }
        this.setState({
            selection: selection
        });
        this.props.onFieldChange(keyValue, selection);
        this.isRequiredCheck(selection);
    }

    companySelectionHandler(keyValue) {
        let key = Object.keys(keyValue)[0];
        let value = Object.values(keyValue)[0];
        let selection = Object.assign({}, this.state.selection);
        if (_.isEmpty(value)) {
            delete selection[key];
            delete selection[PARAM_COMPANY_CODE];
        } else {
            selection = Object.assign(selection, keyValue);
        }
        let adaptedSelection = this.adaptCompanyId(selection);
        this.setState({
            selection: adaptedSelection
        });
        this.props.onFieldChange(keyValue, adaptedSelection);
    }

    onSearchClick() {
        let selection = Object.assign({}, this.state.selection);
        GLOBAL_FILTER_CONTROLLER.bulkChange(selection);
        this.props.onSearchClick(selection);
    }

    onSearchClickInErrorsAndWarnings() {
        let selection = Object.assign({}, this.state.selection);
        
        // Remove companyCode and countryCode if companyId is 'All'
        if (!selection[PARAM_COMPANY_ID] || selection[PARAM_COMPANY_ID] === 'All' || selection[PARAM_COMPANY_ID] === '' || selection[PARAM_COMPANY_ID] === 0) {
            delete selection[PARAM_COMPANY_CODE];
            delete selection[PARAM_COUNTRY_CODE];
        }
        
        // If country filter is disabled (passed as prop), remove countryCode from selection
        if (this.props.isCountryFilterDisabled) {
            delete selection[PARAM_COUNTRY_CODE];
        }
        
        // Update global filter controller with cleaned selection to persist the changes
        GLOBAL_FILTER_CONTROLLER.bulkChange(selection);
        // Also update component state to keep it in sync
        this.setState({ selection: selection });
        this.props.onSearchClick(selection);
    }

    onCustomDatesClick() {
        log.debug('onCustomDatesClick ');

        if (typeof this.props.onCustomDatesClick === 'function')
            this.props.onCustomDatesClick();
    }
    /**
     * Returns the filter period group name
     */
    getFilterPeriodGroup() {
        return this.props.filterPeriodGroup;
    }

    /**
     * Filter period group of {month, year} and {start date, end date} needs to adjust its values to keep them in sync with state values.
     *
     * @param {*} adaptedSelection
     * @memberof GlobalFilterPanel
     */
    adaptFilterPeriod(selection) {
        //Check which group is applicable for the current page
        let adaptedSelection = Object.assign({}, selection);
        let adaptPeriodOptions = this.props.adaptPeriodOptions || {};
        const periodGroup = this.getFilterPeriodGroup();
        let startDate = moment.utc(adaptedSelection.startDate, DATE_FORMAT);
        let endDate = moment.utc(adaptedSelection.endDate, DATE_FORMAT);
        let momentMonth = moment(adaptedSelection.month + '', 'MM');
        let isValidMonth = momentMonth ? momentMonth.isValid() : false;
        let isValidYear = adaptedSelection.year !== undefined && adaptedSelection.year.length === 4;
        let simpleDate = adaptedSelection.date && moment.utc(adaptedSelection.date, DATE_FORMAT);
        switch (periodGroup) {
            case FILTER_PERIOD_GROUP.MONTH_YEAR:
                //If not a valid month
                if (!isValidMonth) {
                    if ((endDate && endDate.isValid()) || (startDate && startDate.isValid())) {
                        let lastPeriodOfDateRange = endDate || startDate;
                        adaptedSelection.month = lastPeriodOfDateRange.format('M');
                    }
                    else if (simpleDate && simpleDate.isValid()) {
                        adaptedSelection.month = simpleDate.format('M');
                    }
                    else if (!this.props.disableMonthYearSpecialValues && NOW === (typeof adaptedSelection.defaultMonth === 'string' && adaptedSelection.defaultMonth.toLowerCase())) {
                        adaptedSelection.month = moment.utc().format('M');
                    }
                    //All other cases will have default month based on todays date
                    else {
                        if (adaptedSelection.month === undefined) {
                            adaptedSelection.month = moment.utc().format('M');
                        } else {
                            adaptedSelection.month = '';//moment.utc().format('M');
                        }

                    }
                }
                //If not a valid year
                if (!isValidYear) {
                    if ((endDate && endDate.isValid()) || (startDate && startDate.isValid())) {
                        let lastPeriodOfDateRange = endDate || startDate;
                        adaptedSelection.year = lastPeriodOfDateRange.format('YYYY');
                    }
                    else if (simpleDate && simpleDate.isValid()) {
                        adaptedSelection.year = simpleDate.format('YYYY');
                    }
                    else if (!this.props.disableMonthYearSpecialValues && NOW === (typeof adaptedSelection.defaultYear === 'string' && adaptedSelection.defaultYear.toLowerCase())) {
                        adaptedSelection.year = moment.utc().format('YYYY');
                    }
                    //All other cases will have default year based on todays date
                    else {
                        adaptedSelection.year = moment.utc().format('YYYY');
                    }
                }
                if (adaptedSelection.month || adaptedSelection.year) {
                    delete adaptedSelection[PARAM_START_DATE];
                    delete adaptedSelection[PARAM_END_DATE];
                    delete adaptedSelection[PARAM_SIMPLE_DATE];
                }
                break;
            case FILTER_PERIOD_GROUP.DATE_RANGE:
                let customDateRange = adaptPeriodOptions && typeof adaptPeriodOptions.customDateRangeProvider === 'function' && adaptPeriodOptions.customDateRangeProvider(adaptedSelection);
                if (customDateRange
                    && customDateRange.startDate
                    && customDateRange.startDate.isValid()
                    && customDateRange.endDate
                    && customDateRange.endDate.isValid()) {
                    adaptedSelection.startDate = customDateRange.startDate.format(DATE_FORMAT);
                    adaptedSelection.endDate = customDateRange.endDate.format(DATE_FORMAT);
                }
                else {
                    if (startDate && startDate.isValid()) {
                        adaptedSelection.startDate = startDate.format(DATE_FORMAT);
                    }
                    if (endDate && endDate.isValid()) {
                        adaptedSelection.endDate = endDate.format(DATE_FORMAT);
                    }
                    let periodDate;
                    // if((isValidMonth && adaptedSelection.month) && (isValidYear && adaptedSelection.year)) {
                    //     periodDate =  moment.utc(`${adaptedSelection.year}-${adaptedSelection.month}-01`, DATE_FORMAT);
                    // }
                    if (isValidYear && adaptedSelection.year) {
                        if (isValidMonth && adaptedSelection.month) {
                            periodDate = moment.utc(`${adaptedSelection.year}-${adaptedSelection.month}-01`, DATE_FORMAT);
                        } else {
                            periodDate = moment.utc(`${adaptedSelection.year}-01-01`, DATE_FORMAT);
                        }
                    }
                    if (!adaptedSelection.startDate && periodDate) {
                        adaptedSelection.startDate = periodDate.startOf('month').format(DATE_FORMAT);
                    }
                    if (!adaptedSelection.endDate && periodDate) {
                        if (isValidMonth) {
                            adaptedSelection.endDate = periodDate.endOf('month').format(DATE_FORMAT);
                        } else {
                            //Range is year if no month value is spcified
                            adaptedSelection.endDate = periodDate.endOf('year').format(DATE_FORMAT);
                        }
                    }
                    if (simpleDate && simpleDate.isValid()) {
                        adaptedSelection.startDate = simpleDate.startOf('month').format(DATE_FORMAT);
                        adaptedSelection.endDate = simpleDate.endOf('month').format(DATE_FORMAT);
                    }
                    else {
                        //Or if its set to special value
                        if (NOW === (typeof adaptedSelection.startDate === 'string' && adaptedSelection.startDate.toLowerCase())) {
                            adaptedSelection.startDate = moment.utc().startOf('month').format(DATE_FORMAT);
                        }
                        if (NOW === (typeof adaptedSelection.endDate === 'string' && adaptedSelection.endDate.toLowerCase())) {
                            adaptedSelection.endDate = moment.utc().endOf('month').format(DATE_FORMAT);
                        }
                    }
                }
                delete adaptedSelection[PARAM_SIMPLE_DATE];
                delete adaptedSelection[PARAM_MONTH];
                delete adaptedSelection[PARAM_YEAR];
                break;
            case FILTER_PERIOD_GROUP.SIMPLE_DATE:
                const fallbackToStartDate = adaptPeriodOptions.fallbackToStartDate;
                if (isValidMonth && isValidYear) {
                    let periodDate = moment.utc(`${adaptedSelection.year}-${adaptedSelection.month}-01`, DATE_FORMAT);
                    adaptedSelection[PARAM_SIMPLE_DATE] = periodDate.startOf('month').format(DATE_FORMAT);
                }
                else if (!fallbackToStartDate && endDate && endDate.isValid()) {
                    adaptedSelection[PARAM_SIMPLE_DATE] = endDate.format(DATE_FORMAT);
                } else if (startDate && startDate.isValid()) {
                    adaptedSelection[PARAM_SIMPLE_DATE] = startDate.format(DATE_FORMAT);
                }
                if (!adaptedSelection[PARAM_SIMPLE_DATE]) {
                    adaptedSelection[PARAM_SIMPLE_DATE] = moment.utc(new Date()).format(DATE_FORMAT);
                }
                delete adaptedSelection.month;
                delete adaptedSelection.year;
                delete adaptedSelection.startDate;
                delete adaptedSelection.endDate;
                break;
            default:
            //Enable everything
        }
        //Remove date control params
        delete adaptedSelection[PARAM_DEFAULT_MONTH];
        delete adaptedSelection[PARAM_DEFAULT_YEAR];
        return adaptedSelection;
    }

    adaptCompanyId(selection = {}) {
        log.debug("adaptCompanyId start", selection);

        if (_.isEmpty(this.props.companyList)) {
            return selection;
        }
        let adaptedSelection = Object.assign({}, selection);
        log.debug("adaptCompanyId", selection, this.props, this.props.fieldOptions);
        // Get company options
        const companyOption = this.getCompanyOptions();
        // In case of useCompanyCode true; we will receive code as value of companyId
        if (companyOption.useCompanyCode) {
            if (_.isEmpty(selection[PARAM_COMPANY_ID] + "")) {
                delete adaptedSelection[PARAM_COMPANY_ID];
                return adaptedSelection;
            }
            // correct company code value
            adaptedSelection[PARAM_COMPANY_CODE] = adaptedSelection[PARAM_COMPANY_ID];
            // Find the company id
            const matchedCompany = this.findCompanyBy("code", selection[PARAM_COMPANY_ID]);
            if (matchedCompany) {
                adaptedSelection[PARAM_COMPANY_ID] = matchedCompany.id;
            }
        }
        // Value of company id is id
        else {
            // On page load
            if (selection[PARAM_COMPANY_ID] === undefined && !_.isEmpty(adaptedSelection[PARAM_COMPANY_CODE])) {
                const matchedCompany = this.findCompanyBy("code", selection[PARAM_COMPANY_CODE]);
                if (matchedCompany) {
                    adaptedSelection[PARAM_COMPANY_ID] = matchedCompany.id;
                }
            }
            // On filter selection
            // if 'All' company selected, remove the previous countryCode selection
            else if (_.isEmpty(selection[PARAM_COMPANY_ID] + "") || (selection[PARAM_COMPANY_ID] == 'All')) {
                delete adaptedSelection[PARAM_COMPANY_CODE];
            } else {
                const matchedCompany = this.findCompanyBy("id", selection[PARAM_COMPANY_ID]);
                if (matchedCompany) {
                    adaptedSelection[PARAM_COMPANY_CODE] = matchedCompany.code;
                }
            }
        }
        return adaptedSelection;
    }

    /**
     * `countries` is recomputed by the parent whenever the selected company changes (it is the
     * authoritative list of countryCode options for that company). If the currently selected
     * countryCode is no longer in that list, drop it so a stale country from a previous company
     * selection is never resubmitted - see VRS-2355.
     */
    adaptCountryCode(selection = {}) {
        const currentCountryCode = selection[PARAM_COUNTRY_CODE];
        if (!currentCountryCode) {
            return selection;
        }
        const validCountryCodes = (this.props.countries || []).map((country) => country.countryCode);
        if (validCountryCodes.includes(currentCountryCode)) {
            return selection;
        }
        let adaptedSelection = Object.assign({}, selection);
        delete adaptedSelection[PARAM_COUNTRY_CODE];
        return adaptedSelection;
    }

    isRequiredCheck(selection) {

        // Required field - startDate
        // Intentionally build on a field by field bases so we can add error / warning messages if needed
        // replicate this logic per field if we have other required fields in the future

        if (this.props.requiredFields && this.props.requiredFields.startDate === true) {
            selection.startDate ? (
                this.setState({ requiredFieldsMet: true })
            ) : (
                this.setState({ requiredFieldsMet: false })
            )
        }
    }

    /**
     * Returns true if the search button needs to disabled
     */
    isSearchDisabled() {
        //Check if global filter criteria is met
        const atLeastOneNeeded = this.props.atLeastOneRequired && _.isEmpty(this.state.selection);
        //Check if user's filter criteria is met
        const disableSearchUserChoice = (typeof this.props.disableSearch === 'function') ? this.props.disableSearch(this.state.selection) : this.props.disableSearch;
        //TODO: AND is forcing user to pass atLeastOneNeeded as true. This needs to be corrected
        return this.props.skipAtLeastOneRequiredCheck ? disableSearchUserChoice : (atLeastOneNeeded && disableSearchUserChoice);
    }

    componentDidUpdate(prevProps) {
        if (this.props.companyList !== prevProps.companyList) {
            let adaptedSelection = this.adaptCompanyId(this.state.selection);
            GLOBAL_FILTER_CONTROLLER.bulkChange(adaptedSelection);
            this.setState({ selection: adaptedSelection });
        }
        if (this.props.countries !== prevProps.countries) {
            let adaptedSelection = this.adaptCountryCode(this.state.selection);
            if (adaptedSelection !== this.state.selection) {
                GLOBAL_FILTER_CONTROLLER.bulkChange(adaptedSelection);
                this.setState({ selection: adaptedSelection });
            }
        }
        if ((this.props.filterPeriodGroup !== prevProps.filterPeriodGroup) || (this.props.adaptPeriodOptions !== prevProps.adaptPeriodOptions)) {
            let adaptedSelection = this.adaptFilterPeriod(this.state.selection);
            GLOBAL_FILTER_CONTROLLER.bulkChange(adaptedSelection);
            this.setState({ selection: adaptedSelection });
        }
        //if(this.props.location && this.props.location.search )
        if (this.props.location && prevProps.location
            && (this.props.location !== prevProps.location)
            && (this.props.location.search !== prevProps.location.search)) {
            let currentSearchParams = QueryString.parse(this.props.location && this.props.location.search);
            let prevSearchParams = QueryString.parse(prevProps.location && prevProps.location.search);
            if (!_.isEqual(currentSearchParams, prevSearchParams)) {
                let keys = Object.keys(currentSearchParams);
                keys.forEach(fieldId => {
                    if (!ALL_PARAMS.includes(fieldId)) {
                        delete currentSearchParams[fieldId]
                    }
                });
                let newSelection = Object.assign({}, this.state.selection, currentSearchParams);
                GLOBAL_FILTER_CONTROLLER.bulkChange(newSelection);
                this.setState({
                    selection: newSelection
                });
            }
        }

    }

    componentDidMount() {
        log.debug('componentDidMount() ');
        let parsedQueryParams = QueryString.parse(this.props.location && this.props.location.search);
        log.debug('componentDidMount(): queryParams', parsedQueryParams);
        //During mounting user gets a chance to override global filter values using query params
        let globalFilterValues = GLOBAL_FILTER_CONTROLLER.getAll();

        Object.keys(parsedQueryParams).forEach((key) => {
            //Is control param
            if (CONTROL_PARAMS.includes(key)) {
                let mappedKey = CONTROL_PARAMS_MAPPING[key] + '';

                if (globalFilterValues[mappedKey]) {
                    delete parsedQueryParams[key];
                }
            }
            else if (!ALL_PARAMS.includes(key)) {
                delete parsedQueryParams[key];
            }
        });
        //User can overwrite stored setting using URL params during initial component mount
        let initialFilterValue = Object.assign({}, GLOBAL_FILTER_CONTROLLER.getAll(), parsedQueryParams);
        //If companyCode is received as url param remove companyId
        if (Object.keys(parsedQueryParams).includes(PARAM_COMPANY_CODE) &&
            (`${globalFilterValues[PARAM_COMPANY_CODE]}` !== `${parsedQueryParams[PARAM_COMPANY_CODE]}`)) {
            delete initialFilterValue[PARAM_COMPANY_ID];
            initialFilterValue = this.adaptCompanyId(initialFilterValue);
        }
        log.debug('componentDidMount(): initialFilterValue', initialFilterValue);
        if (_.isEmpty(initialFilterValue)) {
            return;
        }
        let adaptedSelection = this.adaptFilterPeriod(initialFilterValue);
        log.debug('componentDidMount() - adaptedSelection: ', adaptedSelection);
        //what happens to selected values when a user is navigated the page with elements disabled is controlled with resetDisabledElements
        if (this.props.resetDisabledElements) {
            Object.keys(adaptedSelection).forEach((key) => {
                if (this.props.hideElements[key]) {
                    delete adaptedSelection[key];
                }
            });
        }
        GLOBAL_FILTER_CONTROLLER.bulkChange(adaptedSelection);
        this.setState({selection: adaptedSelection});
    }

   monthYearClickHandler(date) {
        const newMonth = (date.getMonth() + 1).toString();
        const newYear = date.getFullYear().toString();
        
        if (this.state.selection.month !== newMonth || this.state.selection.year !== newYear) {
            const newSelection = {...this.state.selection, month: newMonth, year: newYear};
            this.setState({ selection: newSelection }, () => {
                GLOBAL_FILTER_CONTROLLER.bulkChange(newSelection);
                this.props.onSearchClick(newSelection);
            });
        }
    }

    nextAndPrevMonthClickHandler(event) {
        // Get current month and year selection
        const currentSelection = this.state.selection;
        const currentMonth = currentSelection.month;
        const currentYear = currentSelection.year;

        // Take current month and year values and convert strings to numbers so we can do some maths
        const currentMonthNum = parseInt(currentMonth);
        const currentYearNum = parseInt(currentYear);

        // Set inital new values we'll update in a moment
        let newMonthNum = 1;
        let newYearNum = 1;

        // If click event = 'next' then month is 1-11 add one to month, if month is 12 then month = 1 and add one to year
        // If click event = 'prev' then month equals 2 or more subtract one month, if month is 1 then month = 12 and subtract one year
        if(event === "next"){
            if (currentMonthNum <= 11) {
                newMonthNum = currentMonthNum + 1;
                newYearNum = currentYearNum;
            } else {
                newMonthNum = 1;
                newYearNum = currentYearNum + 1;
            }
        } else {
            if (currentMonthNum >= 2) {
                newMonthNum = currentMonthNum - 1;
                newYearNum = currentYearNum;
            } else {
                newMonthNum = 12;
                newYearNum = currentYearNum - 1;
            }
        }

        // Then convert numbers back to strings
        const newMonthString = newMonthNum.toString();
        const newYearString = newYearNum.toString();

        // Set the new month and year values
        const newSelection = {...currentSelection, month:newMonthString, year:newYearString}
        let selection = Object.assign({}, newSelection);
        GLOBAL_FILTER_CONTROLLER.bulkChange(selection);
        this.props.onSearchClick(selection);
        this.setState({
            selection: newSelection
        });
    }
    getMonthSelector(selection) {
        const year = parseInt(selection[PARAM_YEAR]) || new Date().getFullYear();
        const monthNum = parseInt(selection[PARAM_MONTH]) || new Date().getMonth() + 1;
        const selectedDate = new Date(year, monthNum - 1, 1);
            
        return (
            <s-col span="sm-6 md-6 lg-4 4" className="margin-bottom-md" id="month-picker-section">
                <DatePicker
                    key={`${year}-${monthNum}`}
                    className='month-picker-input text-center text-sm-strong'
                    dateFormat="MMMM-YYYY"
                    showMonthYearPicker
                    selected={selectedDate}
                    onChange={this.monthYearClickHandler}
                    shouldCloseOnSelect={true}
                    closeOnScroll={true}
                    customInput={
                        <button
                            type="button"
                            className="month-picker-button text-center text-sm-strong no-border-shadow"
                            onClick={(e) => e.target.nextSibling?.click()}
                        >
                            {selectedDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
                        </button>
                    }
                />
            </s-col>
        )
    }

    render() {
        log.debug('render() - props: ', this.props);
        let { selection } = this.state;
        selection = selection || {};
        const disableSearch = this.isSearchDisabled();
        const searchButtonClasses = cn('primary', { 'disabled': disableSearch });
        const companySelectorClasses = cn({ 'invisible': this.props.hideElements[PARAM_COMPANY_ID], 'disabled': this.props.disableElements[PARAM_COMPANY_ID] });
        const monthSelectorClasses = cn({ 'invisible': this.props.hideElements[PARAM_MONTH] });
        const yearSelectorClasses = cn({ 'invisible': this.props.hideElements[PARAM_YEAR] });
        const simpleDateClasses = cn({ 'invisible': this.props.hideElements[PARAM_SIMPLE_DATE] });
        const startDateClasses = cn({ 'invisible': this.props.hideElements[PARAM_START_DATE] });
        const endDateClasses = cn({ 'invisible': this.props.hideElements[PARAM_END_DATE] });
        const countrySelectorClasses = cn({ 'disabled': this.props.hideElements[PARAM_COUNTRY_CODE] });
        const companyOptions = this.props.fieldOptions[PARAM_COMPANY_ID] || DEFAULT_FIELD_SETTING[PARAM_COMPANY_ID];
        const filterPeriodGroup = this.getFilterPeriodGroup();
        return (
            <div data-test="component-global-filter" className="component-global-filter">
                <span className={this.props.showXmonthPicker  ? 'block x-monthpicker' : 'display-none'}>
                    <h3 className="margin-bottom-none"><LanguageStringResolver string={companyOptions.labelLanguageString || 'globalFilterPanel_dateSelector'}  /></h3>
                    <s-container className="pad-left-none">
                        <s-row>
                            {this.getMonthSelector(selection)}
                            <span className="margin-bottom-md" id="custom-dates">
                                <fieldset className={this.props.showCustomDatesLink  ? 'custom-dates' : 'custom-dates display-none'}>
                                    <div className="bold margin-top-md">
                                        <span className="divider-left margin-left-sm margin-right-sm"></span>
                                        <button data-testid="custom-dates-btn" className="secondary" onClick={this.onCustomDatesClick} >
                                            <LanguageStringResolver string={this.props.customDatesLabelLanguageString} />
                                        </button>
                                    </div>
                                </fieldset>
                            </span>
                        </s-row>
                    </s-container>
                </span>
                <div className="clear"></div>
                <fieldset className={this.props.hideElements[PARAM_COMPANY_ID] ? 'display-none' : 'mr15'}>
                    <label><LanguageStringResolver string={companyOptions.labelLanguageString || 'globalFilterPanel_filterCompany'} /></label>
                    <SingleCompanySelector
                        companyList={this.props.companyList}
                        fieldName={PARAM_COMPANY_ID}
                        selectionHandler={this.companySelectionHandler}
                        selectedCompanyId={companyOptions.useCompanyCode ? (selection[PARAM_COMPANY_CODE] || '') : (selection[PARAM_COMPANY_ID] || '')}
                        valueCompanyCode={companyOptions.useCompanyCode}
                        customOptions={companyOptions.customOptions}
                        selectValueLanguageStringKey={this.props.companySelectValueLanguageStringKey}
                        extraProps={
                            {
                                className: companySelectorClasses,
                                disabled: this.props.disableElements[PARAM_COMPANY_ID]
                            }
                        }
                    />
                </fieldset>
                <fieldset className={this.props.hideElements[PARAM_COUNTRY_CODE] ? 'display-none' : ''}>
                    <label><LanguageStringResolver string={this.props.labelElements[PARAM_COUNTRY_CODE] || 'globalFilterPanel_filterCountry'} /></label>
                    <SingleCountrySelector
                        countryList={this.props.countries}
                        fieldName={PARAM_COUNTRY_CODE}
                        selectionHandler={this.selectionHandler}
                        selectedCountryCode={selection[PARAM_COUNTRY_CODE] || ''}
                        selectValueLanguageStringKey={this.props.countrySelectValueLanguageStringKey}
                        extraProps={
                            {
                                className: countrySelectorClasses,
                                disabled: this.props.disableElements[PARAM_COUNTRY_CODE],
                                applyLicencesCheck: this.props.applyLicencesCheck
                            }
                        }
                    />
                </fieldset>
                <fieldset className={filterPeriodGroup !== FILTER_PERIOD_GROUP.SIMPLE_DATE || this.props.hideElements[PARAM_SIMPLE_DATE] ? 'display-none' : ''}>
                    <label><LanguageStringResolver string={this.props.labelElements[PARAM_SIMPLE_DATE] || 'globalFilterPanel_simpleDate'} /></label>
                    <SimpleDateSelector
                        selectionHandler={this.selectionHandler}
                        fieldName={PARAM_SIMPLE_DATE}
                        format="yyyy-mm-dd"
                        value={selection[PARAM_SIMPLE_DATE] || ''}
                        extraProps={
                            {
                                className: simpleDateClasses,
                                disabled: this.props.disableElements[PARAM_SIMPLE_DATE]
                            }
                        }
                    />
                </fieldset>
                <div className={(
                    this.props.hideElements[PARAM_MONTH] &&
                    this.props.hideElements[PARAM_YEAR] &&
                    this.props.hideElements[PARAM_START_DATE] &&
                    this.props.hideElements[PARAM_END_DATE]) ? 'display-none' : ''}
                >
                </div>
                <div className={(this.props.hideElements[PARAM_MONTH] && this.props.hideElements[PARAM_YEAR]) ? 'display-none' : ''}>
                    <fieldset className={this.props.hideElements[PARAM_MONTH] ? 'display-none' : ''}>
                        <label className="mr15"><LanguageStringResolver string={this.props.labelElements[PARAM_MONTH] || 'globalFilterPanel_month'} /></label>
                        <MonthSelector
                            selectionHandler={this.selectionHandler}
                            month={selection[PARAM_MONTH] || ''}
                            disabled={this.props.disableElements[PARAM_MONTH]}
                            extraProps={{ className: monthSelectorClasses }}
                            defaultValueLabelKey={this.props.monthSelectValueLabelKey}
                        />

                    </fieldset>
                    <fieldset className={this.props.hideElements[PARAM_YEAR] ? 'display-none' : ''}>
                        <label className="mr15"><LanguageStringResolver string={this.props.labelElements[PARAM_YEAR] || 'globalFilterPanel_year'} /></label>
                        <YearSelector
                            selectionHandler={this.selectionHandler}
                            year={selection[PARAM_YEAR]}
                            extraProps={
                                {
                                    className: yearSelectorClasses,
                                    disabled: this.props.disableElements[PARAM_YEAR]
                                }
                            }
                        />
                    </fieldset>
                </div>
                <div className={(this.props.hideElements[PARAM_START_DATE] && this.props.hideElements[PARAM_END_DATE]) ? 'display-none' : ''} data-test="filter-start-date">
                    <fieldset className={this.props.hideElements[PARAM_START_DATE] ? 'display-none' : ''}>
                        <label><LanguageStringResolver string={this.props.labelElements[PARAM_START_DATE] || 'globalFilterPanel_startDate'} /></label>
                        <SimpleDateSelector
                            selectionHandler={this.selectionHandler}
                            fieldName={PARAM_START_DATE}
                            format="yyyy-mm-dd"
                            value={selection[PARAM_START_DATE] || ''}
                            extraProps={
                                {
                                    className: startDateClasses,
                                    disabled: this.props.disableElements[PARAM_START_DATE]
                                }
                            }
                        />
                    </fieldset>
                    <fieldset className={this.props.hideElements[PARAM_END_DATE] ? 'display-none' : ''} data-test="filter-end-date">
                        <label><LanguageStringResolver string={this.props.labelElements[PARAM_END_DATE] || 'globalFilterPanel_endDate'} /></label>
                        <SimpleDateSelector
                            selectionHandler={this.selectionHandler}
                            fieldName={PARAM_END_DATE}
                            format="yyyy-mm-dd"
                            value={selection[PARAM_END_DATE] || ''}
                            extraProps={
                                {
                                    className: endDateClasses,
                                    disabled: this.props.hideElements[PARAM_END_DATE]
                                }
                            }
                        />
                    </fieldset>
                </div>
                <FilingTypeSelector
                    selectionHandler={this.selectionHandler}
                    selectValueLanguageStringKey="global_All"
                    filingType={this.state.selection.filingType || ''}
                    fieldsetClassName={this.props.hideElements[PARAM_RETURN_TYPE] ? 'display-none' : ''}
                    filteredReturnTypes={this.props.filteredReturnTypes}
                />
                <OpenReturnsStatusSelector
                    selectionHandler={this.selectionHandler}
                    selectValueLanguageStringKey="global_All"
                    status={this.state.selection.status}
                    fieldsetClassName={this.props.hideElements[PARAM_RETURN_STATUS] ? 'display-none' : ''}
                />
                <div>
                    {this.props.children}
                </div>
                <fieldset className="mr0">
                    <button
                        data-testid="global-filter-panel-apply-btn"
                        className={searchButtonClasses}
                        //TODO: skipAtLeastOneRequiredCheck is added to somehow disable the atLeastOneNeeded check and not to affect other page implementations; this needs to corrected later
                        disabled={this.props.skipAtLeastOneRequiredCheck ? disableSearch : (_.isEmpty(selection) && disableSearch) || !this.state.requiredFieldsMet}
                        onClick={this.props.useErrorsAndWarningsSearchClick ? this.onSearchClickInErrorsAndWarnings : this.onSearchClick}>
                        <LanguageStringResolver string={this.props.searchLabelLanguageString} />
                    </button>
                </fieldset>
                <div className="clear"></div>
                {this.props.showPrevNextMonth &&
                <s-row className="pad-top-md">
                    <s-col className="pad-bottom-none" span="6">
                        <button className="link" onClick={this.nextAndPrevMonthClickHandler.bind(this, "prev")}><s-icon name="chevron-left" role="img" aria-label="chevron-left"></s-icon> <LanguageStringResolver string={'globalFilterPanel_previousMonth'} /></button>
                    </s-col>
                    <s-col className="pad-bottom-none" span="6">
                        <button className="link float-right text-right" onClick={this.nextAndPrevMonthClickHandler.bind(this, "next")} ><LanguageStringResolver string={'globalFilterPanel_nextMonth'} /> <s-icon name="chevron-right" role="img" aria-label="chevron-right"></s-icon></button>
                    </s-col>
                </s-row>
                }
            </div>
        );
    }
}


GlobalFilterPanel.defaultProps = {
    resetDisabledElements: false,
    countries: [],
    onFieldChange: () => { },
    onSearchClick: () => { },
    disableSearch: true,
    hideElements: ALL_PARAMS.map((key) => {
        return {
            key: false
        };
    }),
    disableElements: ALL_PARAMS.map((key) => {
        return {
            key: false
        };
    }),
    filterPeriodGroup: FILTER_PERIOD_GROUP.ALL,
    hideDisableElements: true,
    atLeastOneRequired: true,
    requiredElements: ALL_PARAMS.map((key) => {
        return {
            key: false
        };
    }),
    searchLabelLanguageString: 'globalFilterPanel_search',
    valueCompanyCode: false,
    customOptions: [],
    labelElements: {},
    fieldOptions: {},
    adaptPeriodOptions: {
        //Accepts currennt selection id and returns a date range object containing startDate and endDate properties.
        //startDate and endDate must be a valid moment js date object
        customDateRangeProvider: () => { }
    },
    disableMonthYearSpecialValues: false,
    invalidDateValueAsNow: true,
    applyLicencesCheck: true,
    monthSelectValueLabelKey: 'None',
    skipAtLeastOneRequiredCheck: false,
    customDatesLabelLanguageString: 'customDates_link',
    showCustomDatesLink: false,
    showXmonthPicker: false,
    onCustomDatesClick: () => { },
    filteredReturnTypes: [],
    showPrevNextMonth: false,
};

function mapStateToProps(state, props) {
    log.debug('mapStateToProps() - state: ', state);
    log.debug('mapStateToProps() - props: ', props);
    const defaultCompanies = (state.companies && state.companies.data) || [];
    const stateProps = {
        languages: state.languages,
        companyList: props.companies ? props.companies : defaultCompanies
    };
    return stateProps;
}

export default withRouter(connect(mapStateToProps)(GlobalFilterPanel));
